import { render, staticRenderFns } from "./PlateHoverCard.vue?vue&type=template&id=99dbee6a&scoped=true"
import script from "./PlateHoverCard.vue?vue&type=script&lang=js"
export * from "./PlateHoverCard.vue?vue&type=script&lang=js"
import style0 from "./PlateHoverCard.vue?vue&type=style&index=0&id=99dbee6a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99dbee6a",
  null
  
)

export default component.exports